import { useEffect, useRef, useState } from "react";
import ListaVerificacionService from "../../services/listaVerificacionService";
import { InitialTableHistorico } from "../../utils/Initials/ListaVerificacion";
import {
  IItemListaVerificacion,
  IRequetTableHistorico,
} from "../../Interfaces/IListaVerificacion";
import { ISearchBox } from "@fluentui/react";
import { _formatDate } from "../../utils/helpers/dateHelpers";
import { IPaginacion } from "../../Interfaces/filter";

interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useHistoricoAdmin = () => {
  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: new Date(),
    filterFechaFin: new Date(),
  });
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const searchBoxRefTable = useRef<ISearchBox>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [control, setControl] = useState(false)
  const [filter, setFilter] = useState<IRequetTableHistorico>(
    InitialTableHistorico
  );
  const [dataTable, setDataTable] = useState<IItemListaVerificacion[]>([]);
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };
  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        case "supervisor":
          if (o?.key) {
            setFilter({ ...filter, supervisorId: o.key });
          }
          break;
        case "modeloEquipo":
          if (o?.key) {
            setFilter({ ...filter, equipoModeloId: o.key });
          }
          break;
        case "equipo":
          if (o?.key) {
            setFilter({ ...filter, equipoId: o.key });
          }
          break;
        case "tipoEquipo":
          if (o?.key) {
            setFilter({ ...filter, tipoEquipoId: o.key });
          }
          break;
        case "guardia":
          if (o?.key) {
            setFilter({ ...filter, guardia: o.key });
          }
          break;
        default:
          break;
      }
    }
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;

      default:
        break;
    }
  };



  const _onChangeChoiceGroup = (e, o) => {
    if (e !== undefined) {
      setFilter({ ...filter, estadoId: o.key });
    }
  };
  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        let fechaFin = !filterFechas.filterFechaFin || (filterFechas.filterFechaFin as unknown as Date) < date ? date : filterFechas.filterFechaFin;

        setFilterFechas({ ...filterFechas, filterFechaInicio: date, filterFechaFin: fechaFin });
        setFilter({ ...filter, fechaInicio: _formatDate(date, ","), fechaFin: fechaFin ? _formatDate(fechaFin, ",") : "" });
        break;
      case "fin":
        setFilter({ ...filter, fechaFin: _formatDate(date, ",") });
        setFilterFechas({ ...filterFechas, filterFechaFin: date });

        break;
      default:
        break;
    }
  };
  const postTableHistorialCheckList = () => {
    setIsLoading(true);
    ListaVerificacionService.postTablaHistorial(filter).then((res) => {
      if (res.status === 200) {
        setDataTable(res.data.items);
        setPaginacion({
          pages: res.data.pages,
          total: res.data.total,
          page: res.data.page,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };
  
  const limpiarFiltro = () => {
    setFilter(InitialTableHistorico);
    setFilterFechas({
      filterFechaFin: new Date(),
      filterFechaInicio: new Date(),
    });
    setControl((prev) => !prev);  };
  

  const actualizarTabla = () => {
    postTableHistorialCheckList();
  };

  useEffect(() => {
    if (control || filter.search || filter.skip || filter.take ) {
      postTableHistorialCheckList();
      setControl(false)
    }
  }, [control, filter.search, filter.skip, filter.take]);

  return {
    isLoading,
    _onkeyUpSearchTable,
    dataTable,
    onChangeComboBox,
    searchBoxRefTable,
    _onChangeChoiceGroup,
    limpiarFiltro,
    filter,
    _onSelectDate,
    onChangeSkip,
    filterFechas,
    actualizarTabla,
    paginacion,
    postTableHistorialCheckList
  };
};
